import { IXmlNode } from '@/app-modules/server-communications';
import { DefaultStageElement } from '@/components/game/implementations/_default/_domain/models';
import { PrizeWinnerData, PrizeWinner } from '@/components/game/_domain/server/prize-winner/prize-winner-data';
import { safeCast } from '@/helper';

class HamsterRacePrizeWinner extends PrizeWinnerData {
    public totalPlayers: number;
    public totalPrizes: number;

    constructor(node: IXmlNode) {
        super(node);

        this.setWinnerSummaryInfo(node);
    }

    private setWinnerSummaryInfo(node: IXmlNode): void {
        this.totalPlayers = safeCast(node.attributes.totalplayers, 0);
        this.totalWinners = safeCast(node.attributes.Quantity, 0);
        this.totalPrizes = safeCast(node.attributes.totalprizes, 0);
    }

    protected getStages(): DefaultStageElement[] {
        return [];
    }

    protected getWinners(node: IXmlNode): PrizeWinner[] {
        const winnersListResponse = node.childNodes.Winner;
        const winnersList: PrizeWinner[] = new Array<PrizeWinner>();

        if (winnersListResponse) {
            winnersListResponse.forEach((winner) => {
                winnersList.push(new PrizeWinner(winner));
            });

            return winnersList;
        }

        return [];
    }
}

export { HamsterRacePrizeWinner };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/hamster-race/_domain/models/prize-winner.ts